import React from 'react';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Form, Col, Card } from 'react-bootstrap';
import { campotexto, camposelect } from '../campos/campos';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';
import { getDadosToOptions } from '../utils/toolsforms';

class DadosComerciais extends React.Component {

    state = {
        especificacargo: false
    }

    componentDidMount(){
        const cargo = this.props.form.getState();
        if(cargo&&cargo.initialValues&&cargo.initialValues.outroscargos&&cargo.initialValues.outroscargos.length){
            this.setState({especificacargo: true});
        }
        
    }

    handleCargos = (cargos) => {        
        let result = getDadosToOptions(cargos,'idcargo', trad, this.props.trads,tradCampo(this.props.lingua),'SELECIONE');
        return result;
    }

    handleCargoEspecificar = (value) => {
        const cargo = this.props.dadoscargos.filter(itens => (itens.idcargo===parseInt(value)));
        console.log(this.props.dadoscargos);
        this.setState({
            especificacargo: cargo[0].outros==='S'
        })
    }
    
    render(){

        const trads = this.props.trads;
        const lingua = this.props.lingua;
        const campos = this.props.formsPesquisaCampos.filter(item => {
            if (item.baseform && (item.baseform.campo === 'cnpj' && item.ocultacampo === 'N' || item.baseform.campo === 'razaosocial' && item.ocultacampo === 'N')) {
                return item;
            }
        });
        
        if(!campos.length){
            return null;
        }
        
        const required = value => (value ? undefined : trad(trads,'JSOBRIGATORIO',lingua));
        
        return (
            <Card className='mb-3'>
                <Card.Header><Card.Title>{trad(trads,'EMPRESARIAIS',lingua)}</Card.Title></Card.Header>
                <Card.Body>
                    <Form.Row>
                        <Form.Group as={Col} md="3" controlId="cnpj" style={this.props.styles['cnpj']?this.props.styles['cnpj']:{}}>
                            <Field type='tel' 
                            mask="99999999999999"
                            styles={this.props.styles}
                            placeholder={trad(trads,'CNPJ',lingua)} 
                            label={trad(trads,'CNPJ',lingua)} name='cnpj' component={campotexto} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="4" controlId="razaosocial" style={this.props.styles['razaosocial']?this.props.styles['razaosocial']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLEEMP',lingua)} 
                            label={trad(trads,'TITLEEMP',lingua)} name='razaosocial' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="fantasia" style={this.props.styles['fantasia']?this.props.styles['fantasia']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLEFANTASIA',lingua)} 
                            label={trad(trads,'TITLEFANTASIA',lingua)} name='fantasia' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="website" style={this.props.styles['website']?this.props.styles['website']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLESITE',lingua)} 
                            label={trad(trads,'TITLESITE',lingua)} name='website' component={campotexto} />
                        </Form.Group>
                    </Form.Row>

                    {this.props.dadoscargos.length?
                    <Form.Row>
                        <Form.Group as={Col} md="2" controlId="idcargo" style={this.props.styles['idcargo']?this.props.styles['idcargo']:{}}>
                            <Field 
                            styles={this.props.styles}
                            placeholder={trad(trads,'CARGO',lingua)} 
                            options={
                                this.handleCargos(this.props.dadoscargos)
                            }
                            label={trad(trads,'CARGO',lingua)} name='idcargo' component={camposelect} />
                            <OnChange name='idcargo'>
                                {this.handleCargoEspecificar}
                            </OnChange>
                        </Form.Group>
                        {this.state.especificacargo?
                        <Form.Group as={Col} md="10" controlId="outroscargos" style={this.props.styles['outroscargo']?this.props.styles['outroscargo']:{}}>
                            <Field type='text' 
                            required={required}
                            styles={this.props.styles}
                            placeholder={trad(trads,'ESPECIFIQUE',lingua)} 
                            label={trad(trads,'ESPECIFIQUE',lingua)} name='outroscargos' component={campotexto} />
                        </Form.Group>
                        :
                        null
                        }
                        <Form.Group as={Col} md="10" controlId="cargocredencial" style={this.props.styles['cargocredencial']?this.props.styles['cargocredencial']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'CARGO_CREDENCIAL',lingua)} 
                            label={trad(trads,'CARGO_CREDENCIAL',lingua)} name='cargocredencial' component={campotexto} />
                        </Form.Group>                            
                    </Form.Row>
                    :
                    null
                    }
                </Card.Body>
            </Card>
        );
    }
}

export default DadosComerciais;